import React, { Component, PropTypes } from 'react';
import ClassNames from 'classnames';
import Textarea from 'components/TextareaControl';
import { CategoryType } from 'types';
import { translate as t } from 'lang';
import PureRenderMixin from 'react-addons-pure-render-mixin';

import './CargoDescriptionControl.scss';

class CargoDescriptionControl extends Component {

    static propTypes = {
        show: PropTypes.bool.isRequired,
        onChange: PropTypes.func,
        value: PropTypes.string,
        selectedCategory: PropTypes.instanceOf(CategoryType).isRequired,
    }

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    _onDescriptionChange = (event) => {
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    }

    render() {

        var label = 'Описание груза';

        if (this.props.selectedCategory.id === 'people') {
            label = 'Описание перевозки';
        }

        var textareaControlClasses = ClassNames({
            'CargoDescriptionControl--hidden': !this.props.show
        });

        var texareaClasses = ClassNames('CargoDescriptionControl-textarea');

        var placeholder = (this.props.selectedCategory.get('name').toUpperCase() || 'HOUSEHOLD') + '_DESCRIPTION_PLACEHOLDER' ;

        return (
            <div className="CargoDescriptionControl">
                <Textarea
                    className={textareaControlClasses}
                    textareaClassName={texareaClasses}
                    label={label}
                    placeholder={t(placeholder)}
                    onChange={this._onDescriptionChange}
                    value={this.props.value} />
            </div>
        );
    }
}

export default CargoDescriptionControl;


// WEBPACK FOOTER //
// ./client/components/CargoDescriptionControl/CargoDescriptionControl.js